import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { isEmpty } from 'lodash';
import { DealerGroupAction, useDealerGroupProvider } from '../DealerGroup.Hooks';

export default function DealerGroupList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = useDealerGroupProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page class={ThemePageError} sidebar={<Icon class="fas-users" />} header={lang.groups} render={lang.noInfo} />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.distributor}</th>
          <th>{lang.dealers}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: dealerGroup }) => (
            <tr key={dealerGroup.id}>
              <td>{dealerGroup.name}</td>
              <td>{dealerGroup.distributor?.name}</td>
              <td>{!isEmpty(dealerGroup.dealers) ? 'N/A' : dealerGroup.dealers?.map((d) => d.name).join(', ')}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: dealerGroup.id.toString(),
                      action: DealerGroupAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_DEALERGROUP}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: dealerGroup.id.toString(),
                      action: DealerGroupAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_DEALERGROUP}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
